import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/ja';
import 'dayjs/locale/ko';
import 'dayjs/locale/nl';
import 'dayjs/locale/pt-br';
import 'dayjs/locale/ru';
import 'dayjs/locale/zh-cn';
import React from 'react';
import dayjs from 'dayjs';
import { Select } from '../Select';
import { Stepper } from '../Stepper';
import { withTranslate } from '../util';
import { StyledTimeWidget, StyledWidgetInputWrapper } from './TimeWidget.styled';
import { getIs24Hr } from './util';
var _TimeWidget = /*#__PURE__*/function (_React$Component) {
  function _TimeWidget() {
    var _this;
    _classCallCheck(this, _TimeWidget);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, _TimeWidget, [].concat(args));
    _defineProperty(_this, "state", _this.createState(_this.props));
    _defineProperty(_this, "setHour", function (hours) {
      _this.setState({
        hours: hours
      });
    });
    _defineProperty(_this, "setMinute", function (minutes) {
      _this.setState({
        minutes: minutes
      });
    });
    _defineProperty(_this, "setMeridiem", function (meridiem) {
      var time = meridiem === 'am' ? _this.dateTime.subtract(12, 'hour') : _this.dateTime.add(12, 'hour');
      _this.props.onChange(time);
      _this.updateInputs(time);
    });
    _defineProperty(_this, "saveHour", function (hours) {
      var is24Hr = getIs24Hr(_this.props.timeFormat);
      var maxHour = is24Hr ? 24 : 12;
      if (hours == null || hours > maxHour || hours < 0) {
        _this.updateInputs(_this.dateTime);
        return;
      }
      var currentMeridiem = _this.getMeridiem(_this.dateTime);
      var time = _this.dateTime.set('hour', hours);
      if (!is24Hr && currentMeridiem !== _this.getMeridiem(time)) {
        var offset = _this.getMeridiem(_this.dateTime) === 'pm' ? 12 : -12;
        time = time.add(offset, 'hours');
      }
      _this.props.onChange(time);
      _this.updateInputs(time);
    });
    _defineProperty(_this, "saveMinute", function (minutes) {
      if (minutes == null || minutes > 59 || minutes < 0) {
        _this.updateInputs(_this.dateTime);
        return;
      }
      var time = _this.dateTime.set('minute', minutes || 0);
      _this.props.onChange(time);
      _this.updateInputs(time);
    });
    return _this;
  }
  _inherits(_TimeWidget, _React$Component);
  return _createClass(_TimeWidget, [{
    key: "dateTime",
    get: function get() {
      return dayjs(this.props.dateTime) || dayjs();
    }
  }, {
    key: "render",
    value: function render() {
      var _t, _t2, _t3;
      var _this$props = this.props,
        t = _this$props.t,
        timeFormat = _this$props.timeFormat;
      var is24Hr = getIs24Hr(timeFormat);
      return /*#__PURE__*/React.createElement(StyledTimeWidget, {
        role: "group"
      }, /*#__PURE__*/React.createElement(Stepper, {
        "aria-label": (_t = t('citrix-ui:time.hour')) !== null && _t !== void 0 ? _t : '',
        placeholder: "HH",
        maxValue: is24Hr ? 23 : 12,
        minValue: is24Hr ? 0 : 1,
        leadingZero: is24Hr,
        value: this.state.hours,
        onChange: this.setHour,
        onBlur: this.saveHour
      }), /*#__PURE__*/React.createElement(StyledWidgetInputWrapper, null, /*#__PURE__*/React.createElement(Stepper, {
        "aria-label": (_t2 = t('citrix-ui:time.minute')) !== null && _t2 !== void 0 ? _t2 : '',
        placeholder: "MM",
        maxValue: 59,
        minValue: 0,
        leadingZero: true,
        value: this.state.minutes,
        onChange: this.setMinute,
        onBlur: this.saveMinute
      })), !is24Hr && /*#__PURE__*/React.createElement(StyledWidgetInputWrapper, null, /*#__PURE__*/React.createElement(Select, {
        options: [{
          label: t('citrix-ui:time.am'),
          value: 'am'
        }, {
          label: t('citrix-ui:time.pm'),
          value: 'pm'
        }],
        "aria-label": (_t3 = t('citrix-ui:time.am_or_pm')) !== null && _t3 !== void 0 ? _t3 : '',
        value: this.getMeridiem(this.dateTime),
        onChange: this.setMeridiem
      })));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;
      var prevTime = this.createState(prevProps);
      var newTime = this.createState(this.props);
      if (prevTime.hours !== newTime.hours || prevTime.minutes !== newTime.minutes) {
        this.setState(function (_, props) {
          return _this2.createState(props);
        });
      }
    }
  }, {
    key: "updateInputs",
    value: function updateInputs(dateTime) {
      var _this3 = this;
      this.setState(function (_, props) {
        return _this3.createState(_objectSpread(_objectSpread({}, props), {}, {
          dateTime: dateTime
        }));
      });
    }
  }, {
    key: "getMeridiem",
    value: function getMeridiem(time) {
      return time.hour() >= 12 ? 'pm' : 'am';
    }
  }, {
    key: "createState",
    value: function createState(props) {
      if (!props.dateTime) {
        return {
          hours: null,
          minutes: null
        };
      }
      var is24Hr = getIs24Hr(this.props.timeFormat);
      var hours = props.dateTime.toDate().getHours();
      if (!is24Hr && hours > 12) {
        hours = hours - 12;
      }
      if (!is24Hr && hours === 0) {
        hours = 12;
      }
      return {
        hours: hours,
        minutes: props.dateTime.toDate().getMinutes()
      };
    }
  }]);
}(React.Component);
export var TimeWidget = withTranslate(_TimeWidget);